"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomBytes = ((typeof self !== 'undefined' && (self.crypto || self.msCrypto))
    // Browsers
    ? function () {
        var crypto = (self.crypto || self.msCrypto);
        var QUOTA = 65536;
        return function (n) {
            var a = new Uint8Array(n);
            for (var i = 0; i < n; i += QUOTA) {
                crypto.getRandomValues(a.subarray(i, i + Math.min(n - i, QUOTA)));
            }
            return a;
        };
    }
    // Node
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    : function () { return require('crypto').randomBytes; })();
